const charityData = [
  {
    title: 'HÃY CHUNG TAY – NÂNG BƯỚC EM ĐẾN TRƯỜNG',
    description:
      'Bạn thân mến,\nỞ khắp nơi vẫn còn rất nhiều em nhỏ có hoàn cảnh khó khăn, thiếu sách vở, đồng phục, thậm chí không đủ học phí để tiếp tục đến trường. Mỗi cuốn sách, mỗi bộ dụng cụ học tập hay một phần học phí nhỏ bé từ bạn đều có thể trở thành đôi cánh chắp ước mơ học tập cho các em.\n\n💌 Chúng tôi phát động chương trình “Tiếp Sức Đến Trường” nhằm:\n\nTrao học bổng, hỗ trợ học phí cho học sinh nghèo hiếu học.\n\nTặng sách vở, balo, đồ dùng học tập giúp các em có điều kiện học tốt hơn.\n\n🤝 Hãy chung tay cùng chúng tôi bằng cách ủng hộ hiện vật (sách, bút, balo…) hoặc đóng góp tài chính để chương trình được thực hiện rộng rãi hơn.\n\nMỗi sự sẻ chia của bạn – dù nhỏ nhất – đều là món quà quý giá giúp các em tiếp tục con đường học tập và vươn tới tương lai tươi sáng.',
    content: '',
    avatarLink: '/assets/images/charity-01.jpg',
    enable: true,
    countShare: 1241,
    top: 1,
  },
  {
    title: 'BỮA ĂN YÊU THƯƠNG – CHUNG TAY LAN TOẢ YÊU THƯƠNG',
    description:
      'Bạn thân mến,\nNgoài kia, vẫn còn rất nhiều người vô gia cư, bệnh nhân nghèo và lao động thu nhập thấp đang vật lộn với bữa ăn hàng ngày. Một suất cơm nóng, một chai nước sạch, một bộ quần áo ấm… đôi khi chính là động lực giúp họ vượt qua khó khăn.\n\n🌟 Chúng tôi phát động chương trình “Bữa Ăn Yêu Thương” với mong muốn:\n\nChuẩn bị và trao tặng các suất ăn miễn phí cho người vô gia cư, bệnh nhân nghèo tại bệnh viện, người lao động khó khăn.\n\nKèm theo quần áo, nhu yếu phẩm thiết yếu và tư vấn sức khoẻ.\n\n🤝 Mỗi tấm lòng của bạn – dù là một phần gạo, một chai nước, hay một khoản đóng góp nhỏ – đều góp thành hàng trăm suất ăn ấm áp đến tay những người kém may mắn.',
    content: '',
    avatarLink: '/assets/images/charity-02.jpg',
    enable: true,
    countShare: 2351,
    top: 2,
  },
  {
    title: 'QUỸ XÂY TRƯỜNG – NỐI NHỮNG ƯỚC MƠ VÙNG CAO',
    description:
      'Bạn thân mến,\nỞ các vùng cao xa xôi, rất nhiều em nhỏ vẫn phải học trong lớp tạm bợ, dột nát, mùa đông lạnh buốt và mùa mưa gió nguy hiểm. Một ngôi trường vững chãi không chỉ là mái che, mà còn là nơi chắp cánh cho tương lai các em.\n\n🌟 Chúng tôi phát động Quỹ “Xây Trường Vùng Cao” với mục tiêu:\n\nXây dựng, sửa chữa lớp học kiên cố cho học sinh vùng cao.\n\nTrang bị bàn ghế, bảng, sách vở và thiết bị học tập.',
    content: '',
    avatarLink: '/assets/images/charity-03.jpg',
    enable: true,
    countShare: 1438,
    top: 3,
  },
  {
    title: 'QUỸ ỦNG HỘ BÃO LŨ 3 MIỀN',
    description:
      'Những ngày qua, bão lũ đã gây thiệt hại nặng nề cho bà con ở cả ba miền. Nhiều gia đình mất nhà cửa, tài sản, cuộc sống lâm vào cảnh khó khăn. Lúc này, hơn bao giờ hết, chúng ta cần chung tay sẻ chia để giúp đồng bào vượt qua hoạn nạn.\n\n🌟 Chúng tôi phát động Quỹ “Ủng Hộ Bão Lũ 3 Miền” nhằm:\n\nHỗ trợ lương thực, nước sạch, thuốc men cho người dân vùng lũ.\n\nKhôi phục nhà cửa, trường học, công trình thiết yếu sau thiên tai.\n\nGiúp bà con ổn định cuộc sống, sớm trở lại sinh hoạt bình thường.\n\n🤝 Mỗi sự đóng góp – dù là một phần gạo, một bộ quần áo, hay một khoản tiền nhỏ – đều trở thành nguồn động lực lớn lao giúp đồng bào đứng dậy sau bão lũ.',
    content: '',
    avatarLink: '/assets/images/charity-04.png',
    enable: true,
    countShare: 1703,
    top: 4,
  },
];

export default charityData;
